"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var react_router_dom_1 = require("react-router-dom");

var Text_1 = require("../Text");

var styled_components_1 = __importStar(require("../Themes/styled-components"));

var commonStyles = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  text-decoration: none;\n  :hover,\n  :active,\n  :focus {\n    text-decoration: underline;\n  }\n"], ["\n  cursor: pointer;\n  text-decoration: none;\n  :hover,\n  :active,\n  :focus {\n    text-decoration: underline;\n  }\n"])));
var ButtonLink = styled_components_1.default('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  /* resets button styles */\n  padding: 0;\n  border: none;\n  font: inherit;\n  color: ", ";\n  background-color: transparent;\n  text-align: inherit;\n\n  ", "\n"], ["\n  /* resets button styles */\n  padding: 0;\n  border: none;\n  font: inherit;\n  color: ", ";\n  background-color: transparent;\n  text-align: inherit;\n\n  ", "\n"])), function (_a) {
  var color = _a.color;
  return color;
}, commonStyles);
var A = styled_components_1.default('a')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n\n  ", "\n"], ["\n  color: ", ";\n\n  ", "\n"])), function (_a) {
  var color = _a.color;
  return color;
}, commonStyles);
var StyledRouterLink = styled_components_1.default(react_router_dom_1.Link)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n\n  ", "\n"], ["\n  color: ", ";\n\n  ", "\n"])), function (_a) {
  var color = _a.color;
  return color;
}, commonStyles);

var Link =
/** @class */
function (_super) {
  __extends(Link, _super);

  function Link() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Link.prototype.render = function () {
    var _a = this.props,
        href = _a.href,
        to = _a.to,
        onClick = _a.onClick,
        children = _a.children,
        target = _a.target,
        theme = _a.theme,
        primary = _a.primary,
        danger = _a.danger,
        success = _a.success,
        warning = _a.warning,
        faded = _a.faded,
        restProps = __rest(_a, ["href", "to", "onClick", "children", "target", "theme", "primary", "danger", "success", "warning", "faded"]);

    var color = Text_1.getColorFromProps(theme, this.props);

    if (href) {
      return React.createElement(A, __assign({
        href: href,
        color: color
      }, !!target && {
        target: target
      }, {
        onClick: onClick
      }, restProps), children);
    }

    if (to) {
      return React.createElement(StyledRouterLink, __assign({
        to: to,
        color: color,
        onClick: onClick
      }, restProps), children);
    }

    return React.createElement(ButtonLink, __assign({
      type: "button",
      color: color,
      onClick: onClick
    }, restProps), children);
  };

  Link.defaultProps = {
    className: '',
    children: null,
    primary: false,
    danger: false,
    success: false,
    warning: false,
    faded: false
  };
  return Link;
}(React.PureComponent);

exports.default = styled_components_1.withTheme(Link);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;